<template>
    <section class="otstup">
      <div class="container_ur_test">
        <div class="container_test_grid_our Black_2_block  ">
        <div class="container_test_grid_our_in ">
          <div class="container_test_grid_our_in_left">
            <p align="left"  class="text-white text_our_block color_white font_text_ariblk">Выручка, <span class="text_our_block_ed_izmer_ur color_ed_izmer_ur font_text_Arial_regular">млн ₽</span></p>
          </div>
          
        </div>

        

        
       
        <div class="container_test_grid_our_in_urlichz">
          <div class="item_test_viruch_ur" v-for="ur in data_ur_lichza" :key="ur.ur_lichzo_name">
            
            
              <div class="container_ur" >
                <div v-if="ur.color == '1'">
                  <div class="numbers_ur">
                      <p align="left" class="green_text text_19px  font_text_ArialMT">{{ Math.round((ur.sum_fact / ur.sum_plan) * 100) }}%</p>
                  </div>
                </div>
                <div v-if="ur.color == '2'">
                  <div class="numbers_ur">
                      <p align="left" class="red_text text_19px  font_text_ArialMT">{{ Math.round((ur.sum_fact / ur.sum_plan) * 100) }}%</p>
                  </div>
                </div>
                
                <div class="numbers_ur">
                  <p align="left" class="text-white text_18px font_text_Arial_BoldMT">{{ ur.ur_lichzo_name }}</p>
                </div>
                <div v-if="ur.color == '1'">
                  <div class="numbers_ur">
                    <p align="left" class="green_text text_24px  font_text_Arial_BoldMT">{{ formatNumber(ur.sum_fact/1000000) }}</p>
                  </div>
                </div>
                <div v-if="ur.color == '2'">
                  <div class="numbers_ur">
                    <p align="left" class="red_text text_24px  font_text_Arial_BoldMT">{{ formatNumber(ur.sum_fact/1000000) }}</p>
                  </div>
                </div>
              </div>
            
          </div>
          
        </div>

        <div class="container_test_grid_our_in_urlichz_plan ">
          <div class="item_test_viruch_ur" v-for="ur in data_ur_lichza" :key="ur.ur_lichzo_name">
            
              <!-- <div class="container_ur" > -->
                
                
                  <div class="numbers_ur">
                    <p align="left" class="grey_text text_15px  font_text_Arial_BoldMT">из {{ formatNumber(ur.sum_plan/1000000) }}</p>
                  </div>
                
                
              <!-- </div> -->
            
          </div>
          
        </div>
        
      </div>
    </div>
    </section>
</template>


<script setup>
import { useTransitionState } from 'vue';

const props = defineProps({
    data_sum: {
        type: Number,
    },
    data_sum_fact: {
        type: Number,
    },
    data_ur_lichza: {
        type: Array,
    }  
})

// Функция форматирования чисел
const formatNumber = (num) => {
    // Проверяем, что число существует и является числом
    if (num === null || num === undefined || isNaN(num)) return '';
    
    // Проверяем, целое ли число (учитываем и 21000.0)
    const isInteger = Number.isInteger(num);

    // Округляем до 1 знака после запятой, если число не целое
    const roundedNum = isInteger ? num : parseFloat(num.toFixed(1));

    // Форматируем с пробелами и заменяем точку на запятую
    let formatted = roundedNum
        .toString()
        .replace('.', ',') // Меняем точку на запятую
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Добавляем пробелы

    // Убираем ",0" у целых чисел (например, "21 000,0" → "21 000")
    if (isInteger) {
        formatted = formatted.replace(/,0$/, '');
    }

    return formatted;
};

// Пример использования в шаблоне:
// {{ formatNumber(props.data_sum) }}
</script>



<style scoped>
@media (min-width: 0px) and (max-width: 430px) {
  .otstup {
    margin-left: 10px;
    margin-right: 10px;
  }

  .container_ur_test {
    display: grid;
    grid-template-columns: 1fr;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  /* Минимальное расстояние между строками */
  .container_test_grid_our {
    row-gap: 0;                     /* <-- убираем зазор */
  }

  /* Заголовок без нижнего отступа */
  .container_test_grid_our_in {
    display: grid;
    grid-template-columns: 1fr;
    align-items: end;
    justify-content: start;
    margin: 0;
    margin-top: -5px;                     /* <-- больше нет 6px снизу */
  }

  .container_test_grid_our_in_left {
    display: grid;
    align-items: end;
    justify-content: start;
    margin-left: 20px;
    margin-right: 0;
  }

  .text_our_block {
    font-size: 18px;
  }
  .text_our_block_ed_izmer_ur {
    font-size: 14px;
  }

  /* Строки с данными – прижаты друг к другу */
  .container_test_grid_our_in_urlichz,
  .container_test_grid_our_in_urlichz_plan {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin: 0 20px;                /* <-- убираем все вертикальные отступы */
    column-gap: 4px;
    justify-content: stretch;
    align-items: center;
  }

  /* Для плановой строки тоже убираем лишние отступы */
  .container_test_grid_our_in_urlichz_plan {
    margin-top: 0;                 /* было 2px */
    margin-bottom: 15px;             /* было 8px */
  }

  .container_ur {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  /* Плотнее внутри ячейки (процент, название, число) */
  .numbers_ur {
    margin-top: 0px;            /* чуть сильнее сближаем */
    margin-bottom: 0px;
  }

  /* Убираем лишние отступы у текстовых элементов */
  .numbers_ur p,
  .item_test_viruch_ur p {
    margin: 0;                   /* сброс браузерных отступов */
    line-height: 1.4;            /* или 1, чтобы строки были вплотную */
  }

  /* Размеры шрифтов */
  .text_19px { font-size: 14px; }
  .text_18px { font-size: 13px; }
  .text_24px { font-size: 18px; }
  .text_15px { font-size: 12px; }
}









/* ipad */
@media (min-width: 430px) and (max-width: 1300px) {


  .container_test_grid_our_in_stroca_2 {
	display: grid;
	align-items: center;
	justify-content: center;
	grid-template-columns: 3fr 1fr;
	margin-top: -40px;
	/* grid-auto-columns: 50px; */
	/* grid-auto-flow: column; */
	
	/* width: min(100%, 450px); */
  }


    .container_test_grid_our_in_urlichz_plan {
	display: grid;
	align-items: center;
	justify-content: center;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	margin-top: -15px;
	margin-bottom: -10px;
	margin-left: 20px;
	margin-right: 0px;
  
  }

  .container_test_grid_our_in_urlichz {
	display: grid;
	align-items: center;
	justify-content: center;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	margin-top: -30px;
	margin-bottom: 0px;
	margin-left: 20px;
	margin-right: 0px;
	/* grid-auto-columns: 50px; */
	/* grid-auto-flow: column; */
	
	/* width: min(100%, 450px); */
  }




  .container_test_grid_our {
	display: grid;
	align-items: center;
	justify-content: center;
	grid-template-columns: 3fr;
	/* grid-template-rows: min; */
	grid-template-rows: 1fr 1fr;
	column-gap: 8px;
  margin: 0px;
  padding: 0px;
	
	/* margin-right: 500px; */
	/* width: 1920px; */
  }


  .container_ur {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr 1fr;
	margin: 0px;
	padding: 0px;
	
  }


  .text_our_block_plan {
	font-size: 12px;
  }




  .text_our_block {
	font-size: 17px;
  }

  .text_our_block_ed_izmer_ur{
	font-size: 12px;
  }

  .text_our_block_ur {
	font-size: 12px;
  }

  .text_our_block_target {
	/* font-size: 16px; */
	font-size: 18px;
	/* font-size: clamp(8px, 5vw, 16px); */
  }

  .container_test_grid_our_in_right {
	display: grid;
	align-items: center;
	justify-content: end;
	margin-right: 25px;
	
	/* margin-left: 45px; */
	/* grid-template-rows: 1fr 3fr; */
  }

    .container_test_grid_our_in_left {
	display: grid;
	align-items: end;
	justify-content: start;
	/* margin-top: -20px; */
	margin-left: 20px;
	/* margin-left: 45px; */
	/* grid-template-rows: 1fr 3fr; */
  }

  .text_our_block_percent {
	font-size: 28px;
  }

  /* .numbers_ur{
	margin-top: 5px; font-size: 24px;
	margin-left: 0px;
	margin-right: 0px;
	
  } */

  .text_our_block_fact {
	font-size: 30px;
  }

  .iz_ur{
	font-size: 14px;
  }


  .container_test_grid_our_in {
	display: grid;
	align-items: center;
	justify-content: center;
	grid-template-columns: 3fr 1fr;
	margin-bottom: 0px;
	margin-top: -5px;
	/* grid-auto-columns: 50px; */
	/* grid-auto-flow: column; */
	
	/* width: min(100%, 450px); */
  }

  
}


 /* .item_line{
	border: 1px solid white;
  } */

</style>